export enum DestinationTagType {
	DESTINATION_TAG = "destination_tag",
	MESSAGE = "message",
	MEMO = "memo",
	WALLET_OWNER = "wallet_owner",
	WALLET_HOST = "wallet_host"
}
